import { gql } from 'src/generated/gql';

export const POP_IN_CLINIC_SETTINGS_QUERY = gql(`
  query GetPopInClinicSettings {
    staff_popInClinicSettings {
      name
      dataType
      value
    }
  }
`);
